import type {BookmarkFolder} from './Folder';

export const BookmarkTypename = 'Document';

export interface Bookmark {
  __typename: typeof BookmarkTypename;
  id: string;
  channels: string[];
  key: string;
  name: string;
  uri: string;
  folders: BookmarkFolder[];
}

export type FolderOrBookmark = BookmarkFolder | Bookmark;

export type FoldersAndBookmarks = FolderOrBookmark[];

export default Bookmark;